module.exports = __webpack_public_path__ + "media/images/svg/arrow-stem-d99e4f4b73a444d9e5f8bf0b6e6a5458.svg";